export default __webpack_public_path__ + "static/media/M3 (6).22d717e1.jpg";